import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Snackbar,
  Alert,
} from "@mui/material";
import axios from "../../../config/axiosConfig";

const compactFieldSx = {
  "& .MuiInputBase-root": { minHeight: 36 },
  "& .MuiInputBase-input": { py: "8px", fontSize: "0.82rem" },
  "& .MuiInputLabel-root": { fontSize: "0.82rem" },
  "& .MuiSelect-select": { py: "8px" },
};

const initialForm = {
  fecha: "",
  oficina: "",
  descripcion: "",
  referencia: "",
  moneda: "",
  tipo_cambio: "",
  cod_transaccion: "",
  itf: "",
  debito: "",
  credito: "",
  estado: "",
  banco: "",
  id_b: "",
  adicional: "",
  saldo: "",
  observacion: "",
};

const RegisterExtractoModal = ({ open, handleClose, onCreated }) => {
  const [formData, setFormData] = useState(initialForm);
  const [saving, setSaving] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    setSuccessMsg("");
    setErrorMsg("");

    try {
      await axios.post("/api/extracto-historico", formData);
      setSuccessMsg("Registro creado correctamente ✅");
      setFormData(initialForm);
      onCreated();
      handleClose();
    } catch (error) {
      console.error("Error al registrar:", error);
      setErrorMsg("Error al registrar el extracto ❌");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle sx={{ fontWeight: 800, fontSize: "1rem", py: 1.5 }}>Registrar Nuevo Extracto</DialogTitle>
        <DialogContent dividers sx={{ py: 1.5 }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr 1fr" },
              gap: 1.25,
            }}
          >
            {Object.keys(initialForm).map((field) => (
              field === "estado" ? (
                <FormControl key={field} size="small" fullWidth sx={compactFieldSx}>
                  <InputLabel>ESTADO</InputLabel>
                  <Select
                    name="estado"
                    value={formData.estado}
                    label="ESTADO"
                    onChange={handleChange}
                  >
                    <MenuItem value="correcto">Correcto</MenuItem>
                    <MenuItem value="incorrecto">Incorrecto</MenuItem>
                  </Select>
                </FormControl>
              ) : field === "fecha" ? (
                <TextField
                  key={field}
                  size="small"
                  fullWidth
                  type="date"
                  name="fecha"
                  label="FECHA"
                  value={formData.fecha}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  sx={compactFieldSx}
                />
              ) : (
                <TextField
                  key={field}
                  size="small"
                  fullWidth
                  label={field.replace(/_/g, " ").toUpperCase()}
                  name={field}
                  value={formData[field]}
                  onChange={handleChange}
                  sx={compactFieldSx}
                />
              )
            ))}
          </Box>
        </DialogContent>
        <DialogActions sx={{ py: 1, px: 2 }}>
          <Button size="small" onClick={handleClose} color="secondary">Cancelar</Button>
          <Button size="small" onClick={handleSave} variant="contained" disabled={saving}>
            {saving ? "Guardando..." : "Registrar"}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar open={!!successMsg} autoHideDuration={3000} onClose={() => setSuccessMsg("")} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <Alert severity="success" sx={{ width: "100%" }}>{successMsg}</Alert>
      </Snackbar>

      <Snackbar open={!!errorMsg} autoHideDuration={3000} onClose={() => setErrorMsg("")} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <Alert severity="error" sx={{ width: "100%" }}>{errorMsg}</Alert>
      </Snackbar>
    </>
  );
};

export default RegisterExtractoModal;
